import _ from 'lodash'

export const liquidityPoolRewardPercentTemplateWithBreakGlass = _.template(`{
    DROP;
    NIL operation;
    PUSH address "<%= breakGlassContract %>"; # Liquidity Pool Breakglass
    CONTRACT %runLambda (lambda unit (list operation));
    IF_NONE { PUSH int 17; FAILWITH } {};
    PUSH mutez 0;
    LAMBDA unit (list operation) {
        DROP;
        NIL operation;
        PUSH address "<%= contract %>"; # Liquidity Pool
        CONTRACT %updateRewardPercent nat;
        IF_NONE { PUSH int 7; FAILWITH } {};
        PUSH mutez 0;
        PUSH nat <%= rewardPercent %>;
        TRANSFER_TOKENS;
        CONS;
    };
    TRANSFER_TOKENS;
    CONS;
}`)

// Once the break glass contracts are removed we can use these
export const liquidityPoolRewardPercentTemplateWithoutBreakGlass = _.template(`{
    DROP;
    NIL operation;
    PUSH address "<%= contract %>"; # Liquidity Pool
    CONTRACT %updateRewardPercent nat;
    IF_NONE { PUSH int 7; FAILWITH } {};
    PUSH mutez 0;
    PUSH nat <%= rewardPercent %>;
    TRANSFER_TOKENS;
    CONS;
}`)
